import React from "react";

export const BoldIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3013 10.8908C16.1905 10.2767 16.8138 9.26834 16.8138 8.33334C16.8138 6.26167 15.2096 4.66667 13.1471 4.66667H7.41797V17.5H13.8713C15.7871 17.5 17.2721 15.9417 17.2721 14.0258C17.2721 12.6325 16.4838 11.4408 15.3013 10.8908ZM10.168 6.95834H12.918C13.6788 6.95834 14.293 7.5725 14.293 8.33334C14.293 9.09417 13.6788 9.70834 12.918 9.70834H10.168V6.95834ZM13.3763 15.2083H10.168V12.4583H13.3763C14.1371 12.4583 14.7513 13.0725 14.7513 13.8333C14.7513 14.5942 14.1371 15.2083 13.3763 15.2083Z"
        fill="black"
        fill-opacity="0.54"
      />
    </svg>
  );
};
